import { render } from "./ShopSingle.vue?vue&type=template&id=19b75f82"
import script from "./ShopSingle.vue?vue&type=script&lang=js"
export * from "./ShopSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__